export const EMAIL_DOMAIN = 'worldapeiron.com';

export interface CloudEmail {
  id: string;
  owner_id: string;
  local_part: string;
  email: string;
  status: string;
  created_at: string;
  updated_at: string;
  first_name: string | null;
  last_name: string | null;
  country: string | null;
  phone: string | null;
  type: string | null;
  verification_status: string | null;
  verification_doc_url: string | null;
  verification_doc_type: string | null;
  icon_url: string | null;
}

export interface CloudFile {
  id: string;
  owner_id: string;
  name: string;
  size: number;
  type: string | null;
  url: string;
  folder: string;
  created_at: string;
  deleted_at: string | null;
}

export function formatSize(bytes: number): string {
  if (!bytes || bytes < 1024) return `${bytes || 0} o`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} Ko`;
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} Mo`;
  return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} Go`;
}

export function sanitizeLocalPart(input: string): string {
  return input.trim().toLowerCase().replace(/[^a-z0-9._-]/g, '');
}

export function isValidLocalPart(local: string): boolean {
  if (local.length < 3 || local.length > 30) return false;
  if (!/^[a-z0-9._-]+$/.test(local)) return false;
  if (!/^[a-z0-9]/.test(local) || !/[a-z0-9]$/.test(local)) return false;
  if (/[._-]{2,}/.test(local)) return false;
  return true;
}

export function matchesSearch(file: CloudFile, query: string): boolean {
  const q = query.trim().toLowerCase();
  if (!q) return true;
  const ext = file.name.split('.').pop()?.toLowerCase() || '';
  return (
    file.name.toLowerCase().includes(q) ||
    ext.includes(q) ||
    (file.folder || '').toLowerCase().includes(q)
  );
}

export function fileIconFor(name: string, type: string | null): string {
  const ext = name.split('.').pop()?.toLowerCase() || '';
  if (type?.startsWith('image/')) return 'ri-image-line';
  if (type?.startsWith('video/')) return 'ri-video-line';
  if (type?.startsWith('audio/')) return 'ri-music-2-line';
  if (['pdf'].includes(ext)) return 'ri-file-pdf-2-line';
  if (['doc', 'docx'].includes(ext)) return 'ri-file-word-2-line';
  if (['xls', 'xlsx', 'csv'].includes(ext)) return 'ri-file-excel-2-line';
  if (['ppt', 'pptx'].includes(ext)) return 'ri-file-ppt-2-line';
  if (['zip', 'rar', '7z'].includes(ext)) return 'ri-file-zip-line';
  if (['txt', 'md'].includes(ext)) return 'ri-file-text-line';
  if (['js', 'ts', 'tsx', 'jsx', 'py', 'php', 'json'].includes(ext)) return 'ri-code-line';
  return 'ri-file-line';
}